import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";

export default function SubscriptionCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-red-50 px-4">
      <div className="max-w-lg w-full bg-white rounded-3xl shadow-xl border border-red-100 p-6 sm:p-8 text-center">
        
        <div className="flex justify-center">
          <div className="h-14 w-14 rounded-full bg-red-100 flex items-center justify-center mb-4">
            <XCircle className="h-8 w-8 text-red-600" />
          </div>
        </div>

        <h1 className="text-2xl sm:text-3xl font-bold text-slate-900">
          Payment canceled
        </h1>

        <p className="mt-3 text-sm sm:text-base text-slate-600">
          Your subscription payment was canceled. No charges were made.
        </p>

        <div className="mt-6 rounded-2xl bg-red-50 border border-red-100 px-4 py-3 text-left text-xs sm:text-sm text-slate-700">
          <p className="font-semibold text-slate-900">You can try again anytime.</p>
          <p className="mt-1">
            If this was a mistake, you may restart your subscription from the dashboard.
          </p>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => navigate("/dashboard/subscription")}
            className="inline-flex items-center justify-center rounded-xl border border-slate-300 px-5 py-2.5 text-sm font-semibold text-slate-700 bg-white hover:bg-slate-50 transition"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to subscription
          </button>

          <button
            onClick={() => navigate("/dashboard")}
            className="inline-flex items-center justify-center rounded-xl bg-blue-600 px-5 py-2.5 text-sm font-semibold text-white hover:bg-blue-500 transition"
          >
            Go to dashboard
          </button>
        </div>

        <p className="mt-4 text-[11px] text-slate-400">
          If you need help, contact PTfinderNow support.
        </p>
      </div>
    </div>
  );
}
